const Login = () => import(/* webpackChunkName: "login" */ '@/views/Login')
const Prematriculas = () => import(/* webpackChunkName: "prematriculas" */ '@/views/Prematriculas')
const MatriculasNotas = () => import(/* webpackChunkName: "notas" */ '@/views/MatriculasNotas')
const Grupos = () => import(/* webpackChunkName: "grupos" */ '@/views/Grupos')
const Logout = () => import(/* webpackChunkName: "logout" */ '@/views/Logout')
const NotFound = () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound')
const Cursos = () => import(/* webpackChunkName: "cursos" */ '@/views/Cursos')
const Listados = () => import(/* webpackChunkName: "listados" */ '@/views/Listados')
const Remesas = () => import(/* webpackChunkName: "remesas" */ '@/views/Remesas')
const Personas = () => import(/* webpackChunkName: "personas" */ '@/views/Personas')

const routes = [
  { path: '/', name:'home', redirect: '/prematriculas' },
  { path: '/login', name: 'Login', component: Login, meta: { requiresAuth: false } },
  { path: '/cursos', name: 'Cursos', component: Cursos, meta: { requiresAuth: true } },
  { path: '/prematriculas', name: 'Prematriculas', component: Prematriculas, meta: { requiresAuth: true } },
  { path: '/notas', name: 'MatriculasNotas', component: MatriculasNotas, meta: { requiresAuth: true } },
  { path: '/grupos', name: 'Grupos', component: Grupos, meta: { requiresAuth: true } },
  { path: '/listados', name: 'Listados', component: Listados, meta: { requiresAuth: true } },
  { path: '/remesas', name: 'Remesas', component: Remesas, meta: { requiresAuth: true } },
  { path: '/personas', name: 'Personas', component: Personas, meta: { requiresAuth: true } },
  { path: '/logout', name: 'Logout', component: Logout },
  { path: '*', name: 'NotFound', component: NotFound }
]

export default routes